import { Router } from "@angular/router";
import { BaseFpxComponentState, BaseFpxFormHelper, BaseFpxRoGridHandleAction } from "@fpx/core";
import { CommonService } from "src/app/common.service";
import { ProcessShellService } from "src/app/process-shell/services/process-shell.service";
import { ProfilePicChooserService } from "./profile-pic-chooser.service";
import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { DialogService } from "src/app/fpx-core/services/dialog/dialog.service";

export class ProfilePicChooserState extends BaseFpxComponentState {
    showSuggestion: boolean = false;
    isHybrid: boolean = false;
    documentType: string;
    view: string;
    acceptimages="image/*";
}
@Injectable({
    providedIn: 'root'
})
@Injectable()
export class ProfilePicChooserHelper extends BaseFpxFormHelper<ProfilePicChooserState>{
    constructor(public _commonService: CommonService,
        private _router: Router,
        private _dialogService: DialogService,
        private _processShellService: ProcessShellService,
        private _fileUploadService: ProfilePicChooserService,
        private _dialogRef: MatDialogRef<any>
        ){
            super(new ProfilePicChooserState());
        }

    public doPreInit(): void {
        this._processShellService.setFooterVisible(false);
        this.state.isHybrid = this._commonService.isHybrid();

        let formClassName = this._processShellService.formClassName;
        formClassName = formClassName + "onboarding-form";
        this._processShellService.formClassName = formClassName;

        this.state.documentType = this.getRoutingParam('documentType');
        // this.state.view = this.getRoutingParam('frontView') ? 'FRONT' : 'BACK';

        if (this.getFormMode() === "MODIFY") {
            this._commonService.showSpinner();
            this._fileUploadService.fetchDocContent(this.state.documentType).subscribe({
                next: (res: HttpResponse<any>) => {
                    let path = ['process-shell', 'settings', 'profile-pic-capture'];
                    //if(this._commonService.isDesktop()) path.unshift('onboarding');
                    this._router.navigate(path, {
                        queryParams: {
                            imageData: 'data:image/png;base64, '+res.body.doccontent.frontImage,
                            action: this.getFormMode(),
                            additionalDetails: {
                                documentType: this.state.documentType,
                                captureBy: 'browse',
                                // page: {
                                //     front: this.getRoutingParam('frontView'),
                                //     back: this.getRoutingParam('backView')
                                // }
                            }
                        },
                        queryParamsHandling: 'preserve'
                    });
                    this._commonService.hideSpinner();
                },
                error: (reason) => {
                    this._commonService.hideSpinner();
                }
            });
        }

    }
    public doDestroy(): void {
        let formClassName = this._processShellService.formClassName;
        formClassName = formClassName.replace(" profilepic-chooser", "");
        this._processShellService.formClassName = formClassName;
    }
    startTakePhoto($event) {
        this._dialogRef.close({
            file: 'camera'
        })

    }
    onFileSelect($event) {
        let file = $event;
        if(this._commonService.isMobile()){
        let data = this.base64ToFile(file,"acceptimages");
        console.log(data);
        if (data.name[0].length> 2000000) {
            this.showAlert();

        }
        else {
            this._dialogRef.close({
                file: $event
            })
        }
    }
    else if(this._commonService.isDesktop()){
        if (file.size > 2000000 || !file.type.startsWith('image/') ) {
                this.showAlert();
    
            }
            else {
                this._dialogRef.close({
                    file: $event
                })
            }
    }
}
    showAlert() {
        let CBXDialogData = {
            result: 'failure',
            title: 'Unsuccessful',
            message: "The file format / Size of your profile picture is not supported",
            button: ['Retry']
          }
          this._dialogService.open({
            component: 'alert',
            data: CBXDialogData,
            closeFn: (res) => this.onCloseDialog(res)
          })
        //   this.state.isFormSubmitted = false;
    }

    onCloseDialog(res) {
        this._processShellService.triggerFormSubmittedCompleteStatus(true);
      }

    base64ToFile(base64: string, filename: string):File {
        var arr = base64.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = window.atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
    
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
    
        return new File([u8arr], filename, { type: mime });
      }

}